import { FC } from 'react';

import styles from './ColorViewStub.module.less';

export const ColorViewStub: FC = function ColorViewStub() {
  return (
    <div className={styles.stub} title="Add column to scoring if you want to color it" />
  );
};
